import React from 'react';
import styled from 'styled-components';
import { ItemProperty } from './CommonStyles';

interface ICartItemPreorderMessage {
  preOrderMessage: string;
  preOrderNoChargeLabel: string;
}

export const PreOrder = styled(ItemProperty)`
  font-size: 14px;
  letter-spacing: 0.25px;
  margin-top: 8px;
`;

const PreOrderNoShipMsg = styled(PreOrder)`
  margin-top: 0;
`;

const CartItemPreorderMessage = ({
  preOrderMessage,
  preOrderNoChargeLabel,
}: ICartItemPreorderMessage): JSX.Element => (
  <PreOrder className="acac-cart-item-pre-order">
    <PreOrder>{preOrderMessage}</PreOrder>
    <PreOrderNoShipMsg>{preOrderNoChargeLabel}</PreOrderNoShipMsg>
  </PreOrder>
);

export default CartItemPreorderMessage;
